import { render, staticRenderFns } from "./EditVideoDialog.vue?vue&type=template&id=0f96b9d3&scoped=true&lang=pug&"
import script from "./EditVideoDialog.vue?vue&type=script&lang=ts&"
export * from "./EditVideoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditVideoDialog.vue?vue&type=style&index=0&id=0f96b9d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f96b9d3",
  null
  
)

export default component.exports